import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsUpDown, faTrash } from "@fortawesome/free-solid-svg-icons";

const SelectorSortableOption = ({ id, value, onRemove }) => {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

    return (
        <div
            ref={setNodeRef}
            className="flex items-center gap-2"
            style={{
                transform: CSS.Transform.toString(transform),
                transition,
            }}
        >
            <span
                className="cursor-grab active:cursor-grabbing px-2 hover:bg-base-300 hover:cursor-pointer rounded"
                {...attributes}
                {...listeners}
            >
                <FontAwesomeIcon icon={faArrowsUpDown} />
            </span>
            <span className="flex-1">{value}</span>
            <button onClick={onRemove} className="btn btn-error btn-sm">
                <FontAwesomeIcon icon={faTrash} />
            </button>
        </div>
    );
};

export default SelectorSortableOption;
